import { i18n } from "@/plugins/i18n";

export class PropertyFeature {
  columns = [];
  id = "id";

  fillAbles = [
    ["feature.name", i18n.t("feature"), false],
    ["extraPrice", i18n.t("extraPrice"), false],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
